<template>
	<div>
		<div class="conBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<!-- 选项卡 -->
			<div class="navBox f-ct">
				<p class="a">发票管理</p>
			</div>
			<!-- 状态 -->
			<div class="navStatus f-ct">
				<p @click="statusType=0,courseOrderlist(1)" :class="statusType==0?'a':''">全部</p>
				<p @click="statusType=1,courseOrderlist(1)" :class="statusType==1?'a':''">待提交</p>
				<p @click="statusType=2,courseOrderlist(1)" :class="statusType==2?'a':''">待审核</p>
				<p @click="statusType=3,courseOrderlist(1)" :class="statusType==3?'a':''">已审核</p>
				<p @click="statusType=4,courseOrderlist(1)" :class="statusType==4?'a':''">已开票</p>
			</div>
			<div class="zw" v-if="!orderList.length">
				<el-image :src="require('@/static/zw.png')"></el-image>
				<p>暂无相关数据...</p>
			</div>
			<!-- b表格 -->
			<div class="kfpTable" v-if="orderList.length">
				<div class="th f-ct">
					<p class="t1">序号</p>
					<p class="t2">课程名称</p>
					<p class="t3">订单金额</p>
					<p class="t5">申请时间</p>
					<p class="t6">发票类型</p>
					<p class="t7">发票票种</p>
					<p class="t8">申请状态</p>
					<p class="t9">操作</p>
				</div>
				<div class="td f-ct" v-for="(item,index) in orderList">
					<div class="t1">{{item.id}}</div>
					<div class="t2">{{item.courseName}}</div>
					<div class="t3">¥{{item.invoiceMoney}}</div>
					<div class="t5">{{item.createTime}}</div>
					<div class="t6" v-if="item.grantType==1">电子发票</div>
					<div class="t6" v-if="item.grantType==2">纸质发票</div>
					<div class="t7" v-if="item.invoiceType==1">普通发票(个人)</div>
					<div class="t7" v-if="item.invoiceType==2">普通发票(单位)</div>
					<div class="t7" v-if="item.invoiceType==3">专用发票(单位)</div>
					<div class="t8 red" v-if="item.status==0">待提交</div>
					<div class="t8 red" v-if="item.status==1">待审核</div>
					<div class="t8" v-if="item.status==2">已审核</div>
					<div class="t8" v-if="item.status==3">已开票</div>
					<div class="t9 blue" @click="link('/fapiaoMsg',{id:item.id})">查看详情</div>
				</div>
			</div>
			<!-- 分页 -->
			<div class="fenye">
				<el-pagination
				background
				hide-on-single-page
				layout="prev, pager, next,jumper"
				@current-change="goPage"
				:page-size="pageSize"
				:total="total">
				</el-pagination>
			</div>
			
		</div>
	</div>
</template>
<script>
import { memberInvoiceorderInvoiceList,
memberInvoiceorderInvoiceDetail,
memberInvoiceorderInvoiceListC,
memberInvoiceorderInvoiceDetailC
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			statusType:0,
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 列表
			orderList:[],
		}
	},
	mounted() {
		this.courseOrderlist(1)
	},
	methods:{
		// 跳转页
		goPage(e){
			this.pageNum = e
			this.courseOrderlist()
		},
		// 查询课程列表
		async courseOrderlist(def){
			if(def){this.pageNum=1}
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
				orderByColumn: 'id',
				isAsc: 'desc',
			}
			if(this.statusType){
				data.status = this.statusType*1-1
			}
			let res;
			if(this.userType==1){
				res = await memberInvoiceorderInvoiceList(data);
			}
			if(this.userType==2){
				res = await memberInvoiceorderInvoiceListC(data);
			}
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.orderList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.conBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 20px;
	padding: 0 24px;
	padding-bottom: 40px;
}
.navBox{
	border-bottom: 1px solid #EEEEEE;
	// padding: 0 10px;
	p{
		padding-top: 24px;
		padding-bottom: 16px;
		margin-right: 56px;
		font-size: 18px;
		cursor: pointer;
		color: #7D7D89;
		&::after{
			position: absolute;
			content: '';
			width: 0%;
			height: 4px;
			border-radius: 4px;
			background: #3B6492;
			bottom: 0%;
			left: 50%;
			transform: translateX(-50%);
			transition:0.3s;
		}
	}
	.a{
		color: #3B6492;
		font-weight: bold;
		&::after{
			width: 100%;
			transition:0.3s;
		}
	}
}
.navStatus{
	padding-top: 24px;
	padding-bottom: 22px;
	p{
		font-size: 16px;
		color: #545964;
		position: relative;
		margin-right: 50px;
		padding-bottom: 10px;
		cursor: pointer;
		&::after{
			position: absolute;
			content: '';
			width: 0%;
			height: 4px;
			border-radius: 4px;
			background: #3B6492;
			bottom: 0%;
			left: 50%;
			transform: translateX(-50%);
			transition:0.3s;
		}
	}
	.a{
		color: #000;
		font-weight: bold;
		&::after{
			width: 60%;
			transition:0.3s;
		}
	}
}
.kfpTable{
	border: 1px solid #EBEEF5;
	border-bottom: 0;
	// margin-top: 24px;
	// margin-bottom: 40px;
	.th{
		height: 40px;
		background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
		p{
			line-height: 40px;
			text-align: center;
			font-size: 14px;
			color: #333333;
			font-weight: bold;
		}
		.t1{
			width: 80px;
		}
		.t2{
			width: 378px;
		}
		.t3{
			width: 133px;
		}
		.t5{
			width: 255px;
		}
		.t6{
			width: 204px;
		}
		.t7{
			width: 135px;
		}
		.t8{
			width: 135px;
		}
		.t9{
			width: 195px;
		}
	}
	.td{
		border-bottom: 1px solid #EBEEF5;
		align-items: stretch;
		>div{
			line-height: 26px;
			text-align: center;
			font-size: 14px;
			color: #333333;
			border-right: 1px solid #EBEEF5;
			padding: 16px 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			&:last-child{
				border: none;
			}
		}
		.t1{
			width: 80px;
		}
		.t2{
			width: 378px;
		}
		.t3{
			width: 133px;
		}
		.t5{
			width: 255px;
		}
		.t6{
			width: 204px;
		}
		.t7{
			width: 135px;
		}
		.t8{
			width: 135px;
		}
		.t9{
			width: 195px;
			cursor: pointer;
		}
		.red{
			color: #FF5F5A;
		}
		.blue{
			color: #3B6492;
		}
	}
}
</style>